import { http } from '@/utils/http'

import { AffiliateResponse } from './AffiliateInterface'

class AffiliateService {
  async getAffiliate(): Promise<AffiliateResponse> {
    const res = await http.get<AffiliateResponse>(`/profile/referral`)
    return res.data
  }
}

export default new AffiliateService()
